/** The asset activity log's pieces that need no React (0.99.1): who did it, and grouping of repeated events. */
export interface AuditEvent {
  id: string; action: string; outcome: string; detail: Record<string, unknown>; at: string; actor: string | null; actor_kind: string;
}

export const ACTIVITY_FILTERS = [
  { kind: 'all', label: 'All' },
  { kind: 'edits', label: 'Edits' },
  { kind: 'processing', label: 'Processing' },
  { kind: 'sharing', label: 'Sharing & approvals' },
  { kind: 'storage', label: 'Storage' },
] as const;
export type ActivityKind = typeof ACTIVITY_FILTERS[number]['kind'];

export function actorLabel(e: AuditEvent): string {
  if (e.actor) return e.actor;
  if (e.actor_kind === 'service') return 'PRISM';
  if (typeof e.detail.name === 'string' && e.action.startsWith('approval.')) return `${e.detail.name} (via link)`;
  return 'Unknown';
}

/** Events newest first; a group is a run of events in a row with the same action, actor and outcome. */
export interface ActivityGroup { key: string; events: AuditEvent[] }

export function groupActivity(events: AuditEvent[]): ActivityGroup[] {
  const groups: ActivityGroup[] = [];
  for (const e of events) {
    const last = groups[groups.length - 1];
    const head = last?.events[0];
    if (last && head && head.action === e.action && head.outcome === e.outcome && actorLabel(head) === actorLabel(e)) last.events.push(e);
    else groups.push({ key: e.id, events: [e] });
  }
  return groups;
}
